import { ObjectValues } from 'type-alias';

export const USER_SOURCE = {
  Activate: 'ACTIVATE',
  Scim: 'SCIM',
} as const;

export type USER_SOURCE_VALUES = ObjectValues<typeof USER_SOURCE>;
